
			if ("serviceWorker" in navigator && import.meta.env.PROD) {
				window.addEventListener("load", () => {
					navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
				});
			}
		